
import $ from 'jquery';

export function scrollToElem( $element ) {
    $('html, body').animate({
        scrollTop: $( $element ).offset().top
    }, 0);
};

export function scrollToElemFromLocalStorage() {

    if ( ! 'localStorage' in window ) {
        return;
    }

    var $element = localStorage.getItem('scroll-to');
    if ( ! $element ) return;

    // No need to Scroll Twice.
    localStorage.removeItem('scroll-to');

    // Scroll!.
    scrollToElem( $element );
}

$( document ).ready( function() {
    scrollToElemFromLocalStorage();
} );
